module.exports = __webpack_public_path__ + "static/media/general-main.6590e888.png";